import React from 'react'
import User from 'EurestoClass/User'
import EurestoTable from 'Components/EurestoTable'

export default (props) => <EurestoTable hideHeader={props.hideHeader}
      style={Object.assign({
        maxHeight: props.maxHeight || User.CalculHeight.getHeightWanted(70)
      }, props.style || {})}
      datas={props.data}
                                        selectedRowIndex={props.selectedRowIndex}
      onClick={(row) => props.onClick(row.value, props.name)} columns={props.columns || [
      {
        id: 'value',
        show: false,
        type: 'string',
      },
      {
        id: 'label',
        headerClassName: 'EurestoPrimary EurestoText--text',
        filters: ['search'],
        header: <strong style={{
          display: 'block',
          width: '100%'
        }}>{props.title || EurestoI18n.t('commun:Label')}</strong>,
        type: 'string',
        Cell: (row) => row.html || row.label
      },
    ]}/>



// WEBPACK FOOTER //
// ./app/Components/Listing.js